module.exports = __webpack_public_path__ + "static/media/account-admin-icon.38ee9257.svg";